export default class FarreyFrac {
    constructor(listPrev, listNext) {
        this.fracPrev = this.fractObjFromList(listPrev)
        this.fracNext = this.fractObjFromList(listNext)
    }

    fractObjFromList(list) {
        return {
            n: list[0], 
            d: list[1]
        }
    }

    fractListFromObj(fracObj) {
        return [
            fracObj.n, 
            fracObj.d
        ]
    }

    addition(fracObjA, fracObjB) {
        return {
            n: fracObjA.n + fracObjB.n,
            d: fracObjA.d + fracObjB.d
        }
    }

    sumPrevNext() {
        return this.addition(this.fracPrev, this.fracNext)
    }

    gcd(n, d) {
        if(0 === d) {
            return n
        } else {
            return this.gcd(d, n % d)
        }
    }

    sF(fracObj) {
        const { n, d } = fracObj
        const gcd = this.gcd(n, d)

        return {
            n: n / gcd,
            d: d / gcd
        }
    }

    order() {
        try {
            const sumFrac = this.sumPrevNext()
            const sF = this.sF(sumFrac)

            return this.fractListFromObj(sF)
        } catch(e) {
            console.log('error', e)
        }
    }
}